// 网球： 【中网】

// 网球-赛程-常规赛程
const TennisScheduleIndex = () =>
  import(
    /* webpackChunkName: "TennisScheduleIndex" */ '@platfrom/tennis/schedule/index.vue'
  )

// 网球 赛程详情
const TennisScheduleDetail = () =>
  import(
    /* webpackChunkName: "TennisScheduleDetail" */ '@platfrom/tennis/scheduleDetail/index.vue'
  )

// 网球-赛程详情 -> 出场名单
const TennisScheduleDetailStartList = () =>
  import(
    /* webpackChunkName: "TennisScheduleDetailStartList" */ '@platfrom/tennis/scheduleDetail/childPage/startList.vue'
  )

// 网球-赛程详情 -> 本场数据
const TennisScheduleDetailLocalData = () =>
  import(
    /* webpackChunkName: "TennisScheduleDetailLocalData" */ '@platfrom/tennis/scheduleDetail/childPage/localData.vue'
  )

// 网球-赛程详情 -> 数据分析
const TennisScheduleDetailDataAnalysis = () =>
  import(
    /* webpackChunkName: "TennisScheduleDetailDataAnalysis" */ '@platfrom/tennis/scheduleDetail/childPage/dataAnalysis.vue'
  )

// 网球-淘汰赛
const TennisKnockoutRoundsIndex = () =>
  import(
    /* webpackChunkName: "TennisKnockoutRoundsIndex" */ '@platfrom/tennis/knockoutRounds/index.vue'
  )

// 网球-晋级之路
const TennisEventsThemeListIndex = () =>
  import(
    /* webpackChunkName: "TennisEventsThemeListIndex" */ '@platfrom/tennis/eventsThemeList/index.vue'
  )

// 网球-播出单
const TennisBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 网球-数据包装
const TennisDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 网球-节目单
const TennisProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

export default {
  TennisScheduleIndex,
  TennisScheduleDetail,
  TennisScheduleDetailStartList,
  TennisScheduleDetailLocalData,
  TennisScheduleDetailDataAnalysis,
  TennisKnockoutRoundsIndex,
  TennisEventsThemeListIndex,
  TennisBroadcastListIndex,
  TennisDataPackagListIndex,
  TennisProgramListIndex,
}
